import { AxisConfig } from 'eazychart-core';
import { format as d3Format } from 'd3-format';

export type TickFormatter = ((value: unknown) => string) & {
  __specifier?: string;
};

type LinearScaleAxisOptions = {
  domain?: number[];
  maxPadding?: number;
  minPadding?: number;
  max?: number;
  min?: number;
  softMax?: number;
  softMin?: number;
  roundRange?: boolean;
  clamp?: boolean;
};

export type AxisConfigWithSpecifier = AxisConfig &
  LinearScaleAxisOptions & {
    tickFormatSpecifier?: string;
  };

export const createTickFormatter = (specifier: string): TickFormatter => {
  const formatValue = d3Format(specifier);
  const formatter: TickFormatter = (value: unknown) => {
    if (typeof value === 'number') {
      return formatValue(value);
    }
    if (typeof value === 'string' && value !== '') {
      const parsed = Number(value);
      if (!Number.isNaN(parsed)) {
        return formatValue(parsed);
      }
    }
    return String(value ?? '');
  };
  formatter.__specifier = specifier;
  return formatter;
};

export const getTickFormatSpecifier = (tickFormat?: Function): string => {
  if (!tickFormat) {
    return '';
  }
  return (tickFormat as TickFormatter).__specifier ?? '';
};

export const enrichAxisTickFormat = <T extends AxisConfigWithSpecifier>(
  axis?: T
): T | undefined => {
  if (!axis) {
    return axis;
  }

  if (axis.tickFormatSpecifier && typeof axis.tickFormat !== 'function') {
    try {
      const formatter = createTickFormatter(axis.tickFormatSpecifier);
      return {
        ...axis,
        tickFormat: formatter,
      };
    } catch {
      return {
        ...axis,
      };
    }
  }

  return axis;
};
